export default __webpack_public_path__ + "static/logo-visp-88fda61490cc2f81fada9bd1bef7deb4.png";